;(function ($) {
  $.fn.togglize = function (options) {
    const toggleAction = function (event) {
      let $target = $(event.target)
      let $expandableWrapper = event.data.expandableTarget
      const expanded = $target.attr("aria-expanded") === "true" || false
      $target.attr("aria-expanded", !expanded)
      $expandableWrapper.prop("hidden", expanded)
      const expandableHeight = $expandableWrapper[0].scrollHeight
      if (expanded === false && event.data.toggleSettings.animate) {
        $expandableWrapper.css({ "max-height": expandableHeight })
      } else if (expanded === true && event.data.toggleSettings.animate) {
        $expandableWrapper.css({ "max-height": "0" })
      }
    }

    const accordionAction = function (event) {
      let $target = $(event.target)
      const expanded = $target.attr("aria-expanded") === "true" || false
      let $expandableWrapper = event.data.expandableTarget
      if (expanded === false) {
        $expandableWrapper.prop("hidden", false)
        $expandableWrapper.siblings(".expandable").prop("hidden", true)
        $expandableWrapper.siblings(":header").find("button").attr("aria-expanded", false)
        $target.attr("aria-expanded", "true")
        const expandableHeight = $expandableWrapper[0].scrollHeight
        if (event.data.toggleSettings.animate) {
          $expandableWrapper.siblings(".expandable").css({ "max-height": "0" })
          console.log("setting wrapper height to: ", expandableHeight)
          $expandableWrapper.css({ "max-height": expandableHeight })
        }
      }
    }

    const settings = $.extend(
      {
        action: "toggle",
        animate: false,
        animateSpeed: "0.2s",
        firstOpen: true
      },
      options
    )

    return this.each(function makeToggles(index, element) {
      const $copySection = $(element)
      const $headings = $copySection.find(":header")
      $headings.each(function makeButton(index, heading) {
        const $heading = $(heading)
        const headingText = $heading.text()
        $heading.html($("<button>").attr("aria-expanded", "false").addClass("togglize-button").text(headingText))
        const $nonHeadings = $(heading).nextUntil(":header")
        const $expandableWrapper = $("<div>").addClass("expandable").prop("hidden", true)
        if (settings.animate) {
          $expandableWrapper.css({ "max-height": "0", transition: `max-height ease-in-out ${settings.animateSpeed}`, overflow: "hidden" })
        }
        $expandableWrapper.append($nonHeadings)
        $heading.after($expandableWrapper)
        if (settings.action == "toggle") {
          $heading.on("click", "button", { expandableTarget: $expandableWrapper, toggleSettings: settings }, toggleAction)
        }
        if (settings.action == "accordion") {
          $heading.on("click", "button", { expandableTarget: $expandableWrapper, toggleSettings: settings }, accordionAction)
        }
      })
      if (settings.firstOpen) {
        $($headings[0]).find("button").attr("aria-expanded", "true")
        $($headings[0]).next(".expandable").prop("hidden", false)
        if (settings.animate) {
          const expandedHeight = $($headings[0]).next(".expandable")[0].scrollHeight
          $($headings[0]).next(".expandable").css({ "max-height": expandedHeight })
        }
      }
    })
  }
})(jQuery)
